<template>
  <el-container class="preview-container" style="background-color: #f2f2f2;min-height:100%;">
    <div class="preview-main">
      <div class="preview-header">
        <p class="">
          <b>{{paperTitle?paperTitle:'试卷名称'}}</b>
          <span class="fr">
            <el-checkbox v-model="isParsing">显示答案和解析</el-checkbox>
          </span>
        </p>
        <i class="divider-line"></i>
        <p class="score-num">
          <span>满分：{{totalScore}}</span>
          <span>题量：{{totalCount}}</span>
        </p>
      </div>
      <div class="preview-content" v-for="(item,index) in list" :key="index">
        <h2 style="margin:10px 0">
          <span>{{index+1 | NumberToChinese}}、{{item.paper_type | returnQuestionType}}</span>
          <span> （共{{item.count_type}}题、总{{item.single_score}}分）</span>
        </h2>
        <template v-for="(qData,idx) in item.paper_info">
          <ScPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-if="qData.paper_type===1" :key="idx"></ScPreview>
          <McPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===2" :key="idx"></McPreview>
          <JugePreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===3" :key="idx"></JugePreview>
          <FillPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===4" :key="idx"></FillPreview>
          <ShortPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===7" :key="idx"></ShortPreview>
          <ExplainPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===8" :key="idx"></ExplainPreview>
          <TrainPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===9" :key="idx"></TrainPreview>
          <MSPreview :qData="qData" :isParsing="isParsing" :index="idx+1" v-else-if="qData.paper_type===10" :key="idx"></MSPreview>
        </template>
      </div>
    </div>
  </el-container>
</template>
<script>
import { testPreviewData, returnQuestionType, NumberToChinese } from "@/api/contest";
import ScPreview from '@/components/show/SingleChoicePreview';
import McPreview from '@/components/show/MultipleChoicePreview';
import MSPreview from '@/components/show/MultipleSortPreview';
import FillPreview from '@/components/show/FillPreview';
import JugePreview from '@/components/show/JugeMentPreview';
import ShortPreview from '@/components/show/ShortPreview';
import ExplainPreview from '@/components/show/ExplainPreview';
import TrainPreview from '@/components/show/TrainPreview';
export default {
  components: {
    ScPreview,
    McPreview,
    MSPreview,
    FillPreview,
    JugePreview,
    ShortPreview,
    ExplainPreview,
    TrainPreview,
  },
  data() {
    return {
      paperId: '',//试卷id
      paperTitle: '',//试卷名称
      totalScore: '',//满分
      totalCount: '',//总题量
      isParsing: false,//是否显示答案与解析
      list: [],//试卷内容
    }
  },
  mounted() {
    this.paperId = sessionStorage.getItem('paperId')
    if (this.paperId) {
      this.initData()
    }
  },
  methods: {
    initData: function () {
      let params = {
        paper_id: this.paperId
      }
      testPreviewData(params).then(response => {
        this.paperTitle = response.data.paper_title
        this.totalScore = response.data.total_score
        this.totalCount = response.data.count
        this.list = response.data.info
      })
    }
  },
  filters: {
    NumberToChinese: function (num) {
      return NumberToChinese(num);
    },
    returnQuestionType: function (val) {
      return returnQuestionType(val)
    }
  }
}
</script>

<style scoped="">
@import url("../../assets/css/preview.css");
</style>